export default __webpack_public_path__ + "static/media/lateral-right.b3f8d60d.png";